import React, { useState } from 'react';

const Footer = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <>
            <footer className="site-footer style-2" id="footer">
                <div className="footer-top footer-feature background-luminosity"
                    style={{ backgroundImage: "url(images/slider-bg1.jpg)" }}>
                    <div className="coustom_container">
                        <div className="row px-2 px-md-4 ">
                            <div className="col-xl-4 col-lg-12 col-md-12 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="widget widget_about">
                                    <h4 className="widget-title">Quick Contact</h4>
                                    <div className="separator-2 m-b30"></div>
                                    <p>Karamchand Memorial School <br />
                                        NH 709A, Jind-Bhiwani Road, Bass Akbarpur, 125042<br />
                                        Mob. 857 000 3331, 857 000 3338<br />
                                        karamchandmemorialschool@gmail.com
                                    </p>
                                    <div className="dz-social-icon style-3">
                                        <ul>
                                            <li><a target="_blank" className="fab fa-facebook-f"
                                                href="https://www.facebook.com/kcmschoolbass/"></a></li>
                                            <li><a target="_blank" className="fab fa-instagram"
                                                href="https://www.instagram.com/kcmschoolbass/"></a></li>
                                            <li><a target="_blank" className="fab fa-twitter"
                                                href="https://twitter.com/kcmschoolbass"></a></li>
                                            <li><a target="_blank" className="fab fa-youtube"
                                                href="https://www.youtube.com/@KARAMCHANDMEMORIALSCHOOL-je3qw"></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.4s">
                                <div className="widget widget_services">
                                    <h4 className="widget-title">Quick Links</h4>
                                    <div className="separator-2 m-b30"></div>
                                    <ul>
                                        <li><a href="online-registration.html">Online Registration</a></li>
                                        <li><a href="downloads.html">Downloads</a></li>
                                        <li><a href="academic-life.html">Academic life</a></li>
                                        <li><a href="sporting-life.html">Sporting Life </a></li>
                                        <li><a href="co-curricular.html">Co-curricular </a></li>
                                        <li><a href="social-responsibility.html">Social Responsibility</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-2 col-md-4 col-sm-6 wow fadeInUp" data-wow-delay="0.6s">
                                <div className="widget widget_services">
                                    <h4 className="widget-title">Useful Links</h4>
                                    <div className="separator-2 m-b30"></div>
                                    <ul>
                                        <li><a href="our-inspiration.html">Our Inspiration</a></li>
                                        <li><a href="history.html">History</a></li>
                                        <li><a href="activities.html">Activities</a></li>
                                        <li><a href="gallery.html">Photo Gallery</a></li>
                                        <li><a href="#">Video Gallery</a></li>
                                        <li><a href="contact-us.html">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-4 col-md-4 col-sm-12 wow fadeInUp" data-wow-delay="0.8s">
                                <div className="widget widget_locations">
                                    <h4 className="widget-title">Locations</h4>
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3485.983323934914!2d76.20042221509334!3d29.106173682233276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391213b265680209%3A0x9eba238e70fb0310!2sKaramchand%20Memorial%20School%20(KCMS)!5e0!3m2!1sen!2sin!4v1679038588122!5m2!1sen!2sin"
                                        width="100%" height="230" style={{ border: 0 }} allowfullscreen="" loading="lazy"
                                        referrerpolicy="no-referrer-when-downgrade">
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img className="shape1" src="https://kcmschoolbass.com/templates/kcm-school/images/side-images/shape4.png" alt="" />
                    <img className="shape2" src="https://kcmschoolbass.com/templates/kcm-school/images/side-images/shape-line4.png" alt="" />
                    <img className="shape3" src="https://kcmschoolbass.com/templates/kcm-school/images/side-images/shape5.png" alt="" />
                    <img className="shape4" src="https://kcmschoolbass.com/templates/kcm-school/images/side-images/shape-line5.png" alt="" />
                </div>
                <div className="footer-bottom text-center">
                    <div className="container">
                        <span className="copyright-text">© 2023 Karamchand Memorial School | Website Designed & Developed by <a
                            href="https://www.inetbusinesshub.com" target="_blank" style={{ color: '#000' }}>iNET Business Hub</a>
                        </span>
                    </div>
                </div>
            </footer >
        </>
    )
}

export default Footer;